export default __webpack_public_path__ + "static/media/private-class.d79d45c7.jpeg";